import React from "react";
import ct from "class-types.macro";
import LoginLink from "./LoginLink";
import { VariantProps } from ".";

const C = ({ selectedProduct, productListingView }: VariantProps) => {
  return (
    <div className={productListingView === "list" ? "" : ct("pt-5")}>
      <p
        className={ct(
          "font-semibold",
          "text-xs",
          "leading-none",
          "mt-0",
          "text-gray-800",
          productListingView === "list"
            ? ct("mb-0", "xs:text-center")
            : ct("mb-px", "text-center"),
        )}
      >
        To see our price
      </p>
      <p
        className={ct(
          "font-semibold",
          "text-sm",
          "mb-2",
          "text-red-500",
          productListingView === "list"
            ? ct("leading-none", "lowercase", "xs:text-center")
            : ct("leading-tight", "text-center"),
        )}
      >
        {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
          <>
            {"Add to cart or "}
            <LoginLink>login.</LoginLink>
          </>
        ) : (
          "Add this item to your cart."
        )}
        {productListingView === "grid" && (
          <span
            className={ct(
              "font-normal",
              "text-2xs",
              "leading-tight",
              "m-0",
              "text-center",
              "text-gray-800",
              "italic",
              "block",
            )}
          >
            (You can remove it at any time.)
          </span>
        )}
      </p>
    </div>
  );
};

export default C;
